import React, { ReactNode, SFC } from "react";
import { type IRaangeLabelProps , RaangeLabel } from "src/shared/components/RaangeLabel";
import type ILinkable from "src/shared/formatters/ILinkable";

import type {
  IMerchantGroupAbstract,
  IMerchantGroupAbstractNew,
  MerchantGroup,
} from "src/merchantgroups/objects/MerchantGroup";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { MERCHANT_GROUPS_VIEW_PATH } from "src/merchantgroups/views/MerchantGroupsView";
import { GetEditMerchantGroupViewPath } from "src/merchantgroups/views/EditMerchantGroupView";
import { getMerchantGroupDetailViewPath } from "src/merchantgroups/views/MerchantGroupPaths";

import { getMerchantsViewPath } from "src/merchants/views/MerchantPaths";
import BooleanStatusFormatter from "src/shared/formatters/BooleanStatusFormatter";

export interface IMerchantGroupFormatterProps
  extends Omit<IRaangeLabelProps, "fa"> {
  children: MerchantGroup;
}

export interface IMerchantGroupLabelProps
  extends Omit<IRaangeLabelProps, "fa">,
    ILinkable {}

export const MerchantGroupLabel: SFC<IMerchantGroupLabelProps> = (props) => {
  const { hasLink = false } = props;
  const label = (
    <RaangeLabel fa="building" {...props}>
      <FormattedMessage id="merchant_groups" />
    </RaangeLabel>
  );
  if (hasLink) {
    return <Link to={MERCHANT_GROUPS_VIEW_PATH}>{label}</Link>;
  } else {
    return label;
  }
};

export interface IMerchantGroupLogoProps
  extends IMerchantGroupFormatterProps,
    ILinkable {
  size: number;
}

export const MerchantGroupLogo: SFC<IMerchantGroupLogoProps> = (props) => {
  return null;
  // const { merchant, size, hasLink = false } = props;
  // const merchantGroupLogo = (
  //     <div className="logo" style={{width: size + "em", height: size + "em"}} />
  // );
  // if(hasLink) {
  //     const link = GetMerchantGroupDetailViewPath(merchant);
  //     return <Link to={link}>{merchantGroupLogo}</Link>
  // } else {
  //     return merchantGroupLogo;
  // }
};

export const MerchantGroupName = (
  props: {
    children: IMerchantGroupAbstract | IMerchantGroupAbstractNew;
  } & ILinkable,
) => {
  const { children, hasLink = false, ...rest } = props;
  const merchantGroupName = (
    <RaangeLabel fa="building" {...rest}>
      {children.merchantGroupName}
    </RaangeLabel>
  );
  if (hasLink) {
    const link = getMerchantGroupDetailViewPath(children);
    return <Link to={link}>{merchantGroupName}</Link>;
  } else {
    return merchantGroupName;
  }
};

export const MerchantGroupCreate: SFC<Omit<IRaangeLabelProps, "fa">> = (
  props,
) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="merchant_groups.create" />
    </RaangeLabel>
  );
};

export const MerchantGroupEdit: SFC<
  IMerchantGroupFormatterProps & ILinkable
> = (props) => {
  const { hasLink = false, children, ...rest } = props;
  const reactNode: ReactNode = (
    <RaangeLabel fa="pencil-alt" {...rest}>
      <FormattedMessage id="merchant_groups.edit" />
    </RaangeLabel>
  );

  if (hasLink) {
    return <Link to={GetEditMerchantGroupViewPath(children)}>{reactNode}</Link>;
  } else {
    return <span>{reactNode}</span>;
  }
};

export const MerchantGroupMerchants: SFC<
  IMerchantGroupFormatterProps & ILinkable
> = (props) => {
  const { children, hasLink = false, ...rest } = props;
  const merchantGroupName = (
    <RaangeLabel fa="building" {...rest}>
      {children.merchantGroupName}
    </RaangeLabel>
  );
  if (hasLink) {
    const link = getMerchantsViewPath(children);
    return <Link to={link}>{merchantGroupName}</Link>;
  } else {
    return merchantGroupName;
  }
};

export const MerchantGroupStatus: SFC<IMerchantGroupFormatterProps> = (
  props,
) => {
  return (
    <BooleanStatusFormatter>
      {props.children.merchantGroupStatus === "1"}
    </BooleanStatusFormatter>
  );
};
